export const entry = {
  state: {
    init: {
      description:
        'Entry point - a key element of the scheme responsible for receiving calls. Calls are then transferred according to the scheme for their further processing. At the entry point, you must specify the number you should call to get to the routing scheme.'
    },
    ['create-number']: {
      title: 'Add extension number'
    }
  },
  input: {
    number_id: {
      label: 'Entry point number',
      tooltip: 'The entry point number is the number that you can call to connect the PBX.'
    },

    hide_incoming_number: {
      label: 'Hide number'
    },

    caller_id: {
      label: 'Outgoing number',
      tooltip: 'Outgoing number (Caller ID) is the number that will be displayed to the client when he receives an incoming call.'
    },

    record: {
      label: 'All calls recording'
    },

    calls_only: {
      label: 'Recording only live calls',
      description:
        'Recording calls with two or more participants. Exclude recording of automated services.'
    },

    links:{
      label: 'Buy service packages'
    }
  }
};
